// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__q7L3s","comment":"styles_comment__1Zr2J"};